import React from 'react';
import { Link } from 'react-router-dom';

class SimoDevicesTable extends React.Component {
  headers = [
    { label: 'ID', key: 'id', styles: { minWidth: '50px' } },
    { label: 'User ID ', key: 'user_profile', styles: { minWidth: '100px' } },
    {
      label: 'Device SN',
      key: 'serial_number',
      styles: { minWidth: '100px' },
      ordered: false,
    },
    { label: 'Status', key: 'simo_status' },
    { label: 'Account', key: 'account_name', ordered: false },
    {
      label: 'Device Type',
      key: 'device_type_name',
      styles: { minWidth: '70px' },
      ordered: false,
    },
    { label: '', key: 'view', ordered: false },
  ];

  handleChangeFilter = (orderKey, ordered) => {
    const { ordering, changeOrdering, notOrderedKeys = [] } = this.props;

    if (ordered === null || ordered === false) {
      return;
    } // ordering doesn't exists
    if (notOrderedKeys.includes(orderKey)) {
      return true;
    } // odering for this key disabled

    const prevOrderKey = ordering[0] === '-' ? ordering.slice(1) : ordering;

    const filter =
      orderKey === prevOrderKey && ordering[0] === '-'
        ? orderKey
        : `-${orderKey}`;

    changeOrdering(filter);
  };

  renderHeader = ({ key, label, ordered, styles = {} }) => {
    const { ordering, notOrderedKeys = [] } = this.props;
    const orderKey = ordering[0] === '-' ? ordering.slice(1) : ordering;

    return (
      <th
        key={key}
        onClick={() => this.handleChangeFilter(key, ordered)}
        className={
          key && !notOrderedKeys.includes(key) && ordered !== false
            ? 'order-header'
            : ''
        }
        style={styles}
      >
        {label}
        {orderKey === key ? (ordering[0] === '-' ? ' ↓' : ' ↑') : null}
      </th>
    );
  };

  renderHeaders = () => {
    return <tr>{this.headers.map(this.renderHeader)}</tr>;
  };

  render() {
    const { simoDevices, viewUrl, actionComponent } = this.props;

    return (
      <div>
        <table className="table">
          <thead>{this.renderHeaders()}</thead>
          <tbody>
            {simoDevices.length > 0 ? (
              simoDevices.map((device) => (
                <tr key={device.id}>
                  <td>{device.id}</td>
                  <td>{device.user_profile}</td>
                  <td>{device.serial_number}</td>
                  <td>{device.simo_status}</td>
                  <td>{device.account_name}</td>
                  <td>{device.device_type_name}</td>
                  <td>
                    {actionComponent ? (
                      actionComponent(device)
                    ) : (
                      <Link to={viewUrl(device.id)}>View</Link>
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td>No Results</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    );
  }
}

export default SimoDevicesTable;

SimoDevicesTable.defaultProps = { notOrderedKeys: [] };
